import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import { map } from 'rxjs/operators';
import { share } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class TopicService {
    constructor(private http: HttpClient) {}

    private baseUrl = environment.apiurl + 'api/v1/';

    getTopic(topicId): Observable<any> {
      console.log("topicId~~~",topicId)
      let url = this.baseUrl + 'topics/' +topicId;
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          option: 'urlPath'
        })
      };
      return this.http.get(url,httpOptions).pipe(map((res:Response) => {
        let result = [];
        result.push(res);
        console.log("topic service result",result)
        return result;
      }));
    }
}
